export default {
  standings: {
    title: "Standings",
    empty: {
      unavailable: "Standings unavailable right now.",
    },
    labels: {
      ranking: "#",
      team: "Team",
    },
    columns: {
      GP: "GP",
      W: "W",
      L: "L",
      T: "T",
      OTL: "OTL",
      PTS: "PTS",
      PCT: "PCT",
      D: "D",
    },
    picker: {
      conference: "Conference",
      division: "Division",
      overall: "Overall",
    },
    sections: {
      conference: "Conference",
      division: "Division",
      overall: "Overall",
    },
  },
};